import i18n from '@fiverr/i18n/singleton';
import type { EagerJobsTbdSdk } from '@fiverr-private/jtbd_sdk';
import { DEFAULT_CURRENCY } from '@fiverr-private/homepage_utils';
import { openBriefCreationDrawer } from '@fiverr-private/dm_brief_creation_triggers';
import { BRIEF_ICON_URL } from './constants';

export const DynamicMatchingCardImpl = {
    getJobInfo: async ({ context }) => {
        const { locale } = context;

        return {
            shouldDisplayJob: true,
            dismissInfo: {
                isDismissible: false,
            },
            headerText: i18n.t('jobs_tbd.dynamic_matching.header_text', { $scope: locale }),
            jobPages: [
                {
                    title: i18n.t('jobs_tbd.dynamic_matching.title', { $scope: locale }),
                    subtitle: i18n.t('jobs_tbd.dynamic_matching.subtitle', { $scope: locale }),
                    iconUrl: BRIEF_ICON_URL,
                    ctaText: i18n.t('jobs_tbd.dynamic_matching.cta', { $scope: locale }),
                },
            ],
            clickAction: {
                type: 'custom',
            },
        };
    },
    cardCallbacks: {
        customActionCallback: (args) => {
            openBriefCreationDrawer({
                source: 'tailored_homepage',
                currency: args?.currency || DEFAULT_CURRENCY,
            });
        },
    },
} satisfies EagerJobsTbdSdk;
